import React from "react";
import Text from "../../../../_components/Text";
import Modal from "../../../../_components/Modal";
import Button from "../../../../_components/Button";
import IconButton from "../../../../_components/IconButton";

import Toast from "../../../../_components/Toast";
import TableData from "../../../../_components/TableData";
import { Form } from "../../../../_components/Form";

const fields = [
  {
    name: "name",
    label: "Nome",
    required: true,
  },
  {
    name: "email",
    type: "email",
    label: "E-mail",
    required: true,
  },
  {
    name: "phone_number",
    type: "phone_number",
    label: "Telefone",
    required: true,
  },
];

const formOptions = {
  useLayout: true,
  fieldCol: "",
  fieldXs: "12",
  fieldMd: "4",
  fieldLg: "4",
};

import {
  getBranchAccounting as get,
  createBranchAccounting as create,
  updateBranchAccounting as update,
  deacrivateBranchAccounting as deactivate,
} from "../../../../api/branches/accounting";

import Page from "../../../../_components/Layout/Page";
import Row from "../../../../_components/Layout/Row";
import Column from "../../../../_components/Layout/Column";

export default (props) => {
  const ref = React.useRef(null);
  const [data, setData] = React.useState([]);
  const [toast, setToast] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [requesting, setRequesting] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [formFields, setFormFields] = React.useState([]);
  const [accounting, setAccounting] = React.useState({});

  function onSetData(e) {
    setAccounting(e);
    setShow(true);
  }
  function onHide() {
    if (requesting) {
      return;
    }
    setAccounting({});
    setShow(false);
  }
  function onSave() {
    setRequesting(true);
    setToast({});
    const request = accounting.id ? update : create;
    request(accounting)
      .then(() => {
        setShow(false);
        setToast({ show: true, message: "Contador Salvo", type: "success" });
        setTimeout(() => {
          location.reload();
        }, 2000);
      })
      .catch((error) => {
        setTimeout(() => {
          setRequesting(false);
        }, 500);
      });
  }
  function handleDeactivate(id) {
    deactivate(id).then((resp) => (location.href = "/accounting"));
  }

  function load() {
    setLoading(true);
    get()
      .then((resp) => {
        setData(
          resp.map((acc) => {
            return {
              ...acc,
              actions: (
                <React.Fragment>
                  <IconButton
                    onClick={() => handleDeactivate(acc.id)}
                    icon="trash-alt"
                  />
                  <IconButton icon="edit ml-3" onClick={() => onSetData(acc)} />
                </React.Fragment>
              ),
            };
          })
        );
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 500);
      });
  }

  function init() {
    load();
    setFormFields(fields)
    if (window.location.search === "?yes=GO!") {
      setShow(true);
    }
  }
  React.useEffect(init, [ref.current]);
  return (
    <Page loading={loading}>
      <Row>
        <Column col="12">
          <Text>Contadores</Text>
          <Button onClick={() => setShow(true)}>Cadastrar Contador</Button>
          <TableData
            tHead={["Nome", "Email", "Telefone", "Ações"]}
            tBodyKeys={["name", "email", "phone_number", "actions"]}
            data={data}
          />
        </Column>
      </Row>
      <Toast {...toast} />
      <Modal
        show={show}
        size="xl"
        title="Cadastrar contabilidade"
        onHide={onHide}
      >
        <Form
          loading={requesting}
          fields={fields}
          options={formOptions}
          data={accounting}
          onChange={(data) => setAccounting({ ...data })}
          onSubmit={(data) => onSave(data)}
          btnLabel="Cadastrar"
        />
      </Modal>
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/Accounting/index.jsx